import Footer from "../home/footer"
import Header from "../home/header"

const refund=()=>{
    return(
        <>
            <Header/>

            <div className="container-fluid">
                <div className="container p-2">
                    <h5>Return & Refund Policy</h5>
                    <p>
                        <h5>Last updated on Sep 9th 2025</h5><br/>
                        Return <br/>
                        We have a 5-day return policy, which means you have 5 days after receiving your item to request a return. <br/>
                        Once the return product is received it will be inspected and the return will be approved within 2 days<br/>


                        Refunds<br/>
                        We will notify you once we’ve received and inspected your return, and let you know if the refund was approved or not. If approved, you’ll be automatically Credited on your original payment method within 10 business days. Please remember it can take some <br/>
                        time for your bank or credit card company to process and post the refund too.
                    </p>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default refund